// extracted by mini-css-extract-plugin
module.exports = {"c10krhzi":"c10krhzi","hx9tfyy":"hx9tfyy"};